export { app as default } from "./src/Index.bs";
